import { render, staticRenderFns } from "./TcLayout.vue?vue&type=template&id=7f36164a&"
import script from "./TcLayout.vue?vue&type=script&lang=js&"
export * from "./TcLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/branch.goz.fun/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f36164a')) {
      api.createRecord('7f36164a', component.options)
    } else {
      api.reload('7f36164a', component.options)
    }
    module.hot.accept("./TcLayout.vue?vue&type=template&id=7f36164a&", function () {
      api.rerender('7f36164a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Layouts/TcLayout.vue"
export default component.exports